import { Resources } from 'constants/resources';

import { useMutation } from '@tanstack/react-query';
import { createRelatedBankOperation } from 'config/requests/bankOperations';
import { transformRelatedData } from 'pages/Finance/RequestsBankOps/utils/transformRelatedData';
import { queryClient } from 'providers/queryClient';
import { BankOperation } from 'types/embedded/bankOperation';

type Result = {
  createRelatedRequestsBankOps: (data: BankOperation) => void;
};

export function useCreateRelatedRequestsBankOps(
  handleOpenRecordModal: (data: BankOperation) => void,
  setErrors: (e: any) => void,
): Result {
  const { mutate: createRelate } = useMutation({
    mutationFn: (data: BankOperation) => {
      return createRelatedBankOperation(transformRelatedData(data));
    },
    onError: (e: any) => setErrors(e?.data.errors),
    onSuccess: async (data: BankOperation) => {
      await queryClient.invalidateQueries({ queryKey: [Resources.RequestBankOperations] });
      handleOpenRecordModal(data);
    },
  });

  return { createRelatedRequestsBankOps: createRelate };
}
